import { Checkbox, FormControlLabel, FormGroup, Grid2 } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./Header";
import SideNav from "./SideNav";
import { UserRoles, UserRolesInfo } from "../shared/constants/enums";
import { useDispatch, useSelector } from "react-redux";
import {
  setConsentFormOpen,
  setConsentProvided,
  setLeftNavExpand,
} from "../store/currentPreferencesSlice";
import { Button, Loader } from "../shared/ReusableComponents";
import { useState } from "react";
import { logout } from "../store/loginSlice";
import React from "react";
import AlertBox from "../shared/ReusableComponents/AlertBox";
import { AppConfigurationHelper } from "../services/AppConfigurationHelper";
import { sessionRepository } from "../services/sessionRepository";
import { useMsal } from "@azure/msal-react";
import { BrowserUtils } from "@azure/msal-browser";
import { msalStaffConfig } from "./login/auth/authConfig";
import { persistor } from "../store/store";

const Layout = () => {
  const navigate = useNavigate();
  const auth = useSelector((state: any) => state.login);
  const currentPrefs = useSelector((state: any) => state.currentPreferences);
  const userRole = UserRolesInfo[auth.userInfo?.roleId as UserRoles];
  const leftNavExpandMenu = useSelector(
    (state: any) => state.currentPreferences.isLeftNavExpanded
  );

  const { instance } = useMsal();
  const dispatch = useDispatch();
  const [isAlertBoxOpen, setIsAlertBoxOpen] = useState(false);
  const handleLeftNav = () => {
    dispatch(setLeftNavExpand(!leftNavExpandMenu));
  };

  const onConsentAccept = () => {
    dispatch(setConsentProvided(true));
    setIsAlertBoxOpen(false);
    dispatch(setConsentFormOpen(false));
  };
  const onConsentReject = () => {
    dispatch(setConsentProvided(false));
    setIsAlertBoxOpen(false);
    dispatch(setConsentFormOpen(false));
    sessionRepository.Logout().then(() => {
      persistor.purge(); // Clear the persisted state
      instance
        .logoutRedirect({
          account: instance.getActiveAccount(),
          postLogoutRedirectUri: msalStaffConfig.auth.postLogoutRedirectUri,
        })
        .catch((error) => {
          console.log("Logout error:", error);
        });
    });
  };

  const content = (
    <React.Fragment>
      <div
        dangerouslySetInnerHTML={{
          __html:
            AppConfigurationHelper.Instance().otherSettings?.consentContent,
        }}
      />

      <Button
        onClick={onConsentAccept}
        style={{ marginTop: "20px" }}
        size="small"
        fullWidth={false}
        className="consent-agree-btn"
        text={
          AppConfigurationHelper.Instance().otherSettings?.consentButtonText ??
          "Submit"
        }
        textTransform="uppercase"
        isBold={true}
      />
    </React.Fragment>
  );

  if (
    !currentPrefs.isConsentProvided &&
    !isAlertBoxOpen &&
    currentPrefs.isConsentFormOpen
  ) {
    setIsAlertBoxOpen(true);
  }

  return (
    <Grid2
      display="flex"
      flexDirection="column"
      sx={{
        height: "100vh",
      }}
    >
      <AlertBox
        title={
          AppConfigurationHelper.Instance().otherSettings?.consentTitle ??
          "Consent Required"
        }
        content={content}
        onClose={onConsentReject}
        isOpen={isAlertBoxOpen}
      />
      {currentPrefs.isLoading && <Loader />}
      <Header
        name={`${auth.userInfo?.userFirstName} ${auth.userInfo?.userLastName}`}
        role={userRole?.label}
        avatar={auth.userInfo?.avatar}
        leftNavExpandMenu={leftNavExpandMenu}
        setLeftNavExpandMenu={handleLeftNav}
      />
      <Grid2 display="flex" flexGrow={1}>
        <Grid2
          sx={{
            minWidth: leftNavExpandMenu ? "141px" : "270px",
            borderRight: "2px solid rgb(241, 233, 233)",
          }}
        >
          <SideNav
            role={auth.userInfo?.roleId}
            leftNavExpandMenu={leftNavExpandMenu}
          />
        </Grid2>
        <Grid2
          sx={{
            flexGrow: 1,
            backgroundColor: "#F5F5F5",
            padding: "20px",
          }}
        >
          <Outlet></Outlet>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Layout;
